module.exports = __webpack_public_path__ + "static/about-front-8ccd279af88f62d92c499570af1d648b.png";